import React, { useMemo, useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import ScaleIcon from "@mui/icons-material/Scale";
import LinkIcon from "@mui/icons-material/Link";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import AppLayout from "../../components/AppLayout";
import ReportVisaoGeral from "./components/ReportVisaoGeral";
import ReportEntradas from "./components/ReportEntradas";
import ReportSaidas from "./components/ReportSaidas";
import ReportBalanco from "./components/ReportBalanco";
import ReportRastreabilidade from "./components/ReportRastreabilidade";
import ReportFornecimento from "./components/ReportFornecimento";
import { useUser } from "../../context/UserContext";
import {
	ABAS_DE_RELATORIO_DA_GESTAO_DE_FORNECIMENTO,
	ABAS_DE_RELATORIO_FORA_DA_DISTRIBUICAO,
	ehDistribuicao,
	ehGestaoDeFornecimento,
} from "../../utils/licenca";

// Cada aba carrega o próprio conteúdo: com a lista filtrada por licença, casar
// aba e relatório por índice passaria a mostrar o relatório errado.
const tabs = [
	{ label: "Visão Geral", icon: <BarChartIcon sx={{ fontSize: 16 }} />, Content: ReportVisaoGeral },
	{ label: "Entradas", icon: <InputIcon sx={{ fontSize: 16 }} />, Content: ReportEntradas },
	{ label: "Saídas", icon: <OutputIcon sx={{ fontSize: 16 }} />, Content: ReportSaidas },
	{ label: "Balanço de Massa", icon: <ScaleIcon sx={{ fontSize: 16 }} />, Content: ReportBalanco },
	{ label: "Rastreabilidade", icon: <LinkIcon sx={{ fontSize: 16 }} />, Content: ReportRastreabilidade },
	{ label: "Fornecimento", icon: <AgricultureIcon sx={{ fontSize: 16 }} />, Content: ReportFornecimento },
];

function Relatorios() {
	const [tabValue, setTabValue] = useState(0);
	const { user } = useUser();

	// Entradas, saídas, balanço e rastreabilidade detalham compra, venda e
	// produção: fora da licença de gestão de fornecimento, e a API recusa.
	// Na de distribuição vale o inverso — sai só o fornecimento, que é lido
	// inteiro das coletas.
	const abasVisiveis = useMemo(() => {
		if (ehGestaoDeFornecimento(user)) {
			return tabs.filter((tab) =>
				ABAS_DE_RELATORIO_DA_GESTAO_DE_FORNECIMENTO.includes(tab.label)
			);
		}

		if (ehDistribuicao(user)) {
			return tabs.filter(
				(tab) => !ABAS_DE_RELATORIO_FORA_DA_DISTRIBUICAO.includes(tab.label)
			);
		}

		return tabs;
	}, [user]);

	const abaAtual = abasVisiveis[tabValue] ?? abasVisiveis[0];
	const Conteudo = abaAtual?.Content;

	return (
		<AppLayout currentPage="relatorios">
			<Box sx={{ maxWidth: 1400, mx: "auto" }}>
				{/* Header */}
				<Box sx={{ display: { xs: "none", md: "block" }, mb: 3 }}>
					<Typography variant="h4" sx={{ color: "#0f4557", fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
						Relatórios
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88", mt: 0.5 }}>
						Distribuição de Vegetais Frescos
					</Typography>
				</Box>

				{/* Tabs */}
				<Tabs
					value={tabValue}
					onChange={(_, v) => setTabValue(v)}
					variant="scrollable"
					scrollButtons="auto"
					sx={{
						mb: 3,
						bgcolor: "#f1f5f9",
						borderRadius: "12px",
						p: 0.5,
						minHeight: 40,
						"& .MuiTabs-indicator": { display: "none" },
						"& .MuiTab-root": {
							minHeight: 36,
							textTransform: "none",
							fontSize: "0.8rem",
							fontWeight: 500,
							color: "#5a7a88",
							borderRadius: "8px",
							px: 2,
							py: 0.5,
							gap: 0.75,
							"&.Mui-selected": {
								bgcolor: "white",
								color: "#0f4557",
								fontWeight: 600,
								boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
							},
						},
					}}
				>
					{abasVisiveis.map((tab) => (
						<Tab key={tab.label} label={tab.label} icon={tab.icon} iconPosition="start" />
					))}
				</Tabs>

				{/* Tab Content */}
				{Conteudo && <Conteudo />}
			</Box>
		</AppLayout>
	);
}

export default Relatorios;
